import React from 'react'
import HeaderSection from '../HeaderSection/HeaderSection';
import Navbar from '../Navbar/Navbar';
import BannerSection from '../Headersection1/BannerSection';

export default function Header() {
 return (
  <>
   <Navbar/>
   {/* <HeaderSection/> */}
   <BannerSection/>
  
   
  </>
 )
}
